<template>
  <div>
    <b-modal
      id="modalHabilitation"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
      :title="titleModal"
    >
      <template #default>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <b-alert
            :show="habilitationError !== null"
            dismissible
            variant="danger"
          >
            <span v-html="habilitationError"></span>
          </b-alert>
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label for="habilitation"
                  >Habilitation acquise
                  <span class="text-danger">*</span></label
                >
                <v-custom-select
                  label="nom"
                  :options="selectionableHabilitations"
                  :reduce="(habilitation) => habilitation.uuid"
                  v-model="form.habilitation"
                  placeholder="Habilitation acquise"
                >
                  <template v-slot:option="{ nom }">
                    <h5 style="margin: 0">{{ nom }}</h5>
                  </template>
                  <template #no-options> Aucune données </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="habilitation"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
                <div>
                  <input
                    type="hidden"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('habilitation'),
                    }"
                  />
                  <has-error :form="form" field="habilitation"></has-error>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label for="date_acquisition"
                  >Date d'acquisition <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="form.date_acquisition"
                  name="date_acquisition"
                  placeholder="Date d'acquisition"
                  lang="fr"
                  format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('date_acquisition'),
                  }"
                  type="hidden"
                />
                <has-error :form="form" field="date_acquisition"></has-error>
              </div>
            </div>

            <div
              class="col-md-6 col-lg-6"
              v-if="selectedHabilitation && selectedHabilitation.expire"
            >
              <div class="form-group">
                <label for="date_expiration"
                  >Date d'expiration <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="form.date_expiration"
                  name="date_expiration"
                  placeholder="Date d'expiration"
                  lang="fr"
                  format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('date_expiration'),
                  }"
                  type="hidden"
                />
                <has-error :form="form" field="date_expiration"></has-error>
              </div>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalHabilitation')"
        >
          Fermer
        </button>

        <button
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          Enregistrer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import URL from '@/http/rh/employe-habilitation';
import DatePicker from 'vue2-datepicker';
import Form from 'vform';
export default {
  data() {
    return {
      form: new Form({
        employe: '',
        habilitation: '',
        formation: '',
        date_acquisition: this.$options.filters.formatDate(
          new Date(),
          'DD/MM/YYYY'
        ),
        date_expiration: null,
      }),
      habilitationError: null,
      habilitations: [],
      titleModal: 'Enregistrement de nouvelle habilitation',
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    selectedHabilitation() {
      if (this.form.habilitation) {
        let obj = window._.find(
          this.habilitations,
          (d) => d.uuid === this.form.habilitation
        );
        return obj;
      }

      return null;
    },
    selectionableHabilitations() {
      return (
        this.habilitations.filter(
          (c) => !this.currentHabilitations.includes(Number(c.id))
        ) || []
      );
    },
  },
  methods: {
    async create() {
      this.habilitationError = null;
      this.currentHabilitations = this.currentEmploye.current_habilitations
        .filter((c) => c.id !== null)
        .map((item) => item.id);

      this.habilitations = [];
      this.titleModal = 'Enregistrement de nouvelle habilitation';
      this.form.reset();
      this.form.clear();
      await window.axios
        .get(URL.GET_REQUIREMENTS, {
          params: {
            formation: this.currentSession.formation.id,
          },
        })
        .then((resp) => {
          this.habilitations = resp.data.habilitations;
        })
        .catch();

      await this.$bvModal.show('modalHabilitation');
    },
    submit() {
      this.habilitationError = null;
      this.$bvModal.hide('modalHabilitation');
      this.form.employe = this.currentEmploye.uuid;
      this.form.formation = this.currentSession.formation.uuid;

      this.form
        .post(URL.HABILITATION)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);

          this.form.reset();
          this.form.clear();
          this.$emit('onSuccessSaved');
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('habilitationError')) {
              this.habilitationError = value[0];
            }
            return false;
          });
          this.$bvModal.show('modalHabilitation');
        });
    },
  },
  props: ['currentEmploye', 'currentSession'],
};
</script>

<style scoped lang="scss"></style>
